export default __webpack_public_path__ + "static/media/logo-250.bec1e086.png";